import { Field, FieldProps } from 'formik';

import classNames from 'classnames';
import TooltipWrapper from 'modules/tournaments/ui/components/form-parts/rules/components/fields/tooltip-wrapper';
import { TooltipPosition } from 'modules/tournaments/ui/components/form-parts/rules/components/fields/types';
import UDText from 'ud-ui/components/text';
import UDFormLabel from '../components/label';
import { UDFormComponentProps } from '../components/types';

type Props = UDFormComponentProps & {
  children: (fieldProps: FieldProps<any>) => JSX.Element;
};

const UDFormFieldWrapper = (props: Props) => {
  const { name, containerProps, labelProps, label, children, errorVisible, tooltip, tooltipProps } = props;
  const tooltipPosition = tooltipProps?.position || 'right';

  const renderTooltip = (position: TooltipPosition) => {
    const updatedTooltipProps = tooltipProps ? { ...tooltipProps, position } : { position };
    return <TooltipWrapper tooltip={tooltip} tooltipProps={updatedTooltipProps} />;
  };

  return (
    <Field name={name}>
      {(fieldProps: FieldProps<any>) => {
        const isTouched = fieldProps.meta.touched;
        const errorText = getErrorText(fieldProps.meta.error);
        const isErrorVisible = (errorVisible || label) && isTouched && errorText;

        return (
          <div {...containerProps} className={classNames('d-flex flex-column w-100', containerProps?.className)}>
            {label && (
              <div className="d-flex align-items-center">
                {tooltipPosition === 'left' && renderTooltip('left')}
                <UDFormLabel {...labelProps} className={classNames({ 'mb-2': !isErrorVisible }, labelProps?.className)}>
                  {label}
                </UDFormLabel>
                {tooltipPosition === 'right' && renderTooltip('right')}
              </div>
            )}
            {isErrorVisible && (
              <UDText type="caption-1" className="color-CaseError">
                {errorText}
              </UDText>
            )}
            <div className="d-flex align-items-center w-100">
              {tooltipPosition === 'input-left' && renderTooltip('input-left')}
              {children(fieldProps)}
              {tooltipPosition === 'input-right' && renderTooltip('input-right')}
            </div>
          </div>
        );
      }}
    </Field>
  );
};

export default UDFormFieldWrapper;

const getErrorText = (error: string | object | undefined): string => {
  if (typeof error === 'string') {
    return error;
  } else if (typeof error === 'object' && error !== null) {
    return Object.values(error)[0] as string;
  }
  return '';
};
